<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DContentTemplateEditor',
  extends: compoment
}
</script>
